var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3684 46H10",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6842 49.6846C23.9749 49.6846 24.2105 49.9202 24.2105 50.2109V50.2109C24.2105 50.5016 23.9749 50.7372 23.6842 50.7372V50.7372C23.3935 50.7372 23.1579 50.5016 23.1579 50.2109V50.2109C23.1579 49.9202 23.3935 49.6846 23.6842 49.6846",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3684 36.5263V50.2105C37.3684 52.5359 35.4833 54.421 33.1579 54.421H14.2105C11.8851 54.421 10 52.5359 10 50.2105V10.2105C10 7.88512 11.8851 6 14.2105 6H19.4737",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3961 13.0588C27.8825 13.033 28.3478 12.8518 28.7236 12.5418L30.9412 10.5169C31.3168 10.2067 31.7822 10.0255 32.2687 10H35.7435C36.2257 10.0281 36.6865 10.2091 37.0588 10.5169L39.2764 12.5418C39.6522 12.8518 40.1175 13.033 40.6039 13.0588H44.7057C46.0206 13.194 47.0154 14.3095 46.9998 15.6312V26.0586C46.9998 27.3256 45.9727 28.3527 44.7057 28.3527H23.2943C22.0273 28.3527 21.0002 27.3256 21.0002 26.0586V15.6312C20.9846 14.3095 21.9794 13.194 23.2943 13.0588H27.3961Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0002 23.7642C36.323 23.7642 38.206 21.8812 38.206 19.5584C38.206 17.2356 36.323 15.3525 34.0002 15.3525C31.6774 15.3525 29.7944 17.2356 29.7944 19.5584C29.7944 21.8812 31.6774 23.7642 34.0002 23.7642Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1764 16.5C43.3876 16.5 43.5588 16.6712 43.5588 16.8823C43.5588 17.0935 43.3876 17.2647 43.1764 17.2647C42.9653 17.2647 42.7941 17.0935 42.7941 16.8823C42.7941 16.6712 42.9653 16.5 43.1764 16.5",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.ff87ee3c.svg";
export { ForwardRef as ReactComponent };